import React from 'react'
import Sala from '../Sala'
import VerticalConnection from '../Connections/VerticalConnection'
import HorizontalConnection from '../Connections/HorizontalConnection'
import DiagonalConnectionOne from '../Connections/DiagonalConnectionOne'
import DiagonalConnectionTwo from '../Connections/DiagonalConnectionTwo'
//import VerticalConnection2 from '../Connections2/VerticalConnection2'
//import HorizontalConnection2 from '../Connections2/HorizontalConnection2'
// import DiagonalConnection2One from '../Connections2/DiagonalConnection2One'
// import DiagonalConnection2Two from '../Connections2/DiagonalConnection2Two'
import { useState } from "react"
import Animacao from '../Animacao'
import {getNodesId} from '../Animacao';

export const Cenario1 = ({ start, distancesC1, algorithm }) => { 
    const [startNode, setStartNode] = useState(0)
    const idCenario = 1

    const clearAndStart = (startNodeId) => {   
        document.getElementById('alert-achou-caminho').setAttribute("style", "display:none");
        if(start === true) { //limpa cenário apenas se estiver 'sujo'
            var nodesInShortestPathOrder = getNodesId()
            if(nodesInShortestPathOrder !== undefined && nodesInShortestPathOrder !== null)
                clearNodesConnections(nodesInShortestPathOrder)
        }  
        setStartNode(startNodeId)
    }
      
    const clearNodesConnections = (nodesInShortestPathOrder) => {
        var classNameOrig, classNameConnectionV, classNameConnectionH, classNameConnectionD1, classNameConnectionD2
        classNameOrig = 'sala-cenario1'
        classNameConnectionV = 'vertical-connection-cenario1'
        classNameConnectionH = 'horizontal-connection-cenario1'
        classNameConnectionD1 = 'diagonal-connection-one-cenario1'
        classNameConnectionD2 = 'diagonal-connection-two-cenario1'
      
        for (let i = 0; i < nodesInShortestPathOrder.length; i++) {
          //Limpar salas
          const node = nodesInShortestPathOrder[i];
          document.getElementById(`${node}`).children.item(0).className = classNameOrig;
      
          //Limpar connections
          if(i !== nodesInShortestPathOrder.length - 1) { 
            let node1 = nodesInShortestPathOrder[i];
            let node2 = nodesInShortestPathOrder[i+1];
            if (node1 > node2) {
              let aux = node1;
              node1 = node2;
              node2 = aux;
            }
            const connectionId = parseInt('1' + node1.toString() + node2.toString(), 10);
            const connectionType = document.getElementById(`${connectionId}`).children.item(0).id;
           if(connectionType === '111') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionV;
            } else if(connectionType === '222') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionH;
            } else if(connectionType === '333') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD1;
            } else if(connectionType === '444') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD2;
            }           
          }
        }
    }

    return ( 
        <>
            {/* CENÁRIO */} 
            <div>
                <div id={0}><Sala idCenario={idCenario} onClick={() => clearAndStart(0)}/> </div>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                <Sala idCenario={idCenario} isTransparente={true}/>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                <div id={1}><Sala idCenario={idCenario} onClick={() => clearAndStart(1)}/> </div>
            </div>
            <div>
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/>  {/* margemAcima={40} */}
                {/* <div style={{ float: 'left'}}> <HorizontalConnection2/> </div> */}
                <div id={102}><DiagonalConnectionTwo idCenario={idCenario} distance={distancesC1[0].toFixed(1)}/></div>                   
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/>
                <DiagonalConnectionOne idCenario={idCenario} isTransparente={true}/>
                <div id={113}><HorizontalConnection idCenario={idCenario} distance={distancesC1[1].toFixed(1)}/></div>                
            </div>
            <div>
                <Sala idCenario={idCenario} isTransparente={true}/>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                
                <div id={2}><Sala idCenario={idCenario} onClick={() => clearAndStart(2)}/></div> 
                <div id={123}><VerticalConnection idCenario={idCenario} distance={distancesC1[2].toFixed(1)}/></div>

                <div id={3}><Sala idCenario={idCenario} onClick={() => clearAndStart(3)}/></div> 
            </div>
            <div>
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/>
                <div id={124}><DiagonalConnectionOne idCenario={idCenario} distance={distancesC1[3].toFixed(1)}/></div>                   
                <div id={125}><HorizontalConnection idCenario={idCenario} margemAcima={40} distance={distancesC1[4].toFixed(1)}/></div> 
                <div id={135}><DiagonalConnectionOne idCenario={idCenario} distance={distancesC1[5].toFixed(1)}/></div>               
            </div>
            <div>
                <div id={4}><Sala idCenario={idCenario} onClick={() => clearAndStart(4)}/></div> 
                <div id={145}><VerticalConnection idCenario={idCenario} distance={distancesC1[6].toFixed(1)}/></div>
                
                <div id={5}><Sala idCenario={idCenario} onClick={() => clearAndStart(5)}/> </div>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
               
                <Sala idCenario={idCenario} isTransparente={true}/>
            </div>
            <div>
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/> 
                <DiagonalConnectionOne idCenario={idCenario} isTransparente={true}/>                   
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/>
                <div id={156}><DiagonalConnectionTwo idCenario={idCenario} distance={distancesC1[7].toFixed(1)}/></div>                
            </div>
            <div>
                <Sala idCenario={idCenario} isTransparente={true}/>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                
                <Sala idCenario={idCenario} isTransparente={true}/> 
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>

                <div id={6}><Sala idCenario={idCenario} onClick={() => clearAndStart(6)}/></div>  
            </div>
            <div>
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/>  
                <DiagonalConnectionOne idCenario={idCenario} isTransparente={true}/>                   
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/> {/*margemAcima={40} */}
                <div id={168}><DiagonalConnectionOne idCenario={idCenario} distance={distancesC1[8].toFixed(1)}/></div>                
            </div>
            <div>
                <div id={7}><Sala idCenario={idCenario} onClick={() => clearAndStart(7)}/> </div>
                <div id={178}><VerticalConnection idCenario={idCenario} distance={distancesC1[9].toFixed(1)}/></div>
                
                <div id={8}><Sala idCenario={idCenario} onClick={() => clearAndStart(8)}/> </div>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
               
                <Sala idCenario={idCenario} isTransparente={true}/>
            </div>
            <div>
                <div id={179}><HorizontalConnection idCenario={idCenario} margemAcima={40} distance={distancesC1[10].toFixed(1)}/></div>
                <div id={189}><DiagonalConnectionOne idCenario={idCenario} distance={distancesC1[11].toFixed(1)}/></div>                   
                <div id={1810}><HorizontalConnection idCenario={idCenario} distance={distancesC1[12].toFixed(1)}/></div>
                <DiagonalConnectionOne idCenario={idCenario} isTransparente={true}/>                
            </div>
            <div>
                <div id={9}><Sala idCenario={idCenario} onClick={() => clearAndStart(9)}/> </div>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                
                <div id={10}><Sala idCenario={idCenario} onClick={() => clearAndStart(10)}/></div>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>

                <Sala idCenario={idCenario} isTransparente={true}/> 
            </div>
            <div>
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/>
                <div id={1911}><DiagonalConnectionTwo idCenario={idCenario} distance={distancesC1[13].toFixed(1)}/></div>                   
                <div id={11011}><HorizontalConnection idCenario={idCenario} distance={distancesC1[14].toFixed(1)}/></div> 
                <DiagonalConnectionOne idCenario={idCenario} isTransparente={true}/>              
            </div>
            <div>
                <Sala idCenario={idCenario} isTransparente={true}/>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                
                <div id={11}><Sala idCenario={idCenario} onClick={() => clearAndStart(11)}/> </div>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
               
                <Sala idCenario={idCenario} isTransparente={true}/>
            </div>

            {/* COMEÇAR ANIMAÇÃO*/}
            {start && <Animacao start={start} startNode={startNode} idCenario={1} distances={distancesC1} algorithm={algorithm}/>}
        </>
    )
}

export default Cenario1